import { useQuery } from "@tanstack/react-query";
import { useAddInState } from "@/components/AddInStateProvider";
import { useGeotabClient } from "@/components/GeotabClientContext";
import createUserGroupFilter from "@/utilities/createUserGroupFilter";

/**
 * Returns the user with the given id.
 *
 * @param id - The id of the user.
 * @returns - The {@link User}.
 */
export function useUserById(id?: string) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  const { groups, groupFilterCondition } = useAddInState();
  return useQuery({
    queryKey: ["user", activeSessionId, id, groups, groupFilterCondition],

    queryFn: ({ signal }) => {
      if (!id) {
        return Promise.resolve(null);
      }
      const filter = createUserGroupFilter(groups, groupFilterCondition, { id });
      return geotabClient.get("User", filter, 1, signal).then(users => users[0] ?? null);
    },
  });
}
